/*
 * action types
 */

export const ADD_FORM = 'ADD_FORM';
export const DISABLE_FORM = 'DISABLE_FORM';
export const ENABLE_FORM = 'ENABLE_FORM';
export const SUBMIT_FORM = 'SUBMIT_FORM';

/*
 * action creators
 */

export function addForm(formName) {
  return {
    type: ADD_FORM,
    formName
  };
}

export function disableForm(formName) {
  return {
    type: DISABLE_FORM,
    formName
  };
}

export function enableForm(formName) {
  return {
    type: ENABLE_FORM,
    formName
  };
}

export function submitForm(formName, successMsg) {
  return {
    type: SUBMIT_FORM,
    formName,
    successMsg
  };
}



// WEBPACK FOOTER //
// ./src/actions/form.js